import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as mainStatePreviousFactSheets from '../reducers';
import * as fromsubStatePreviousFactSheet from '../reducers/get-previous-factsheet.reducer';

export const previousFactSheetsRequest = createSelector(
  mainStatePreviousFactSheets.selectGetPreviousFactSheetState,
  fromsubStatePreviousFactSheet.selectPreviousFactSheets
);

export const previousFactSheetsLoaded = createSelector(
  mainStatePreviousFactSheets.selectGetPreviousFactSheetState,
  fromsubStatePreviousFactSheet.selectPreviousFactSheetsLoaded
);

export const previousFactSheetsFailure = createSelector(
  mainStatePreviousFactSheets.selectGetPreviousFactSheetState,
  fromsubStatePreviousFactSheet.selectPreviousFactSheetsError
);
